export class RetrieveOrganisation {
  static readonly type = '[User] RetrieveOrganisation';
}
